/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { ActiveMapState } from '../../state/active-map.state';
import { WindowRefService } from '../../../../core/ui/services/windowRef.service';
import { MapService } from '../../services/map.service';
import { Store } from '@ngxs/store';

export class LaunchGoogleMapsCommand extends MapCommand {

    private store: Store;
    private mapService: MapService;
    private windowRef: WindowRefService;

    invoke() {
        const center = this.mapService.centerLatLon;
        const zoom = this.store.selectSnapshot(ActiveMapState.zoom);
        const url = `https://www.google.com/maps/@${ center[1] },${ center[0] },${ zoom }z`;
        this.windowRef.nativeWindow.open(url, '', null);
        this.deactivate$.next();
    }

    protected onCommandInit() {
        super.onCommandInit();
        this.store = <Store>this.deps['store'];
        this.mapService = <MapService>this.deps['mapService'];
        this.windowRef = <WindowRefService>this.deps['windowRef'];
    }
}
